import {Checkbox, Modal, Spin} from "antd";
import {useDispatch, useSelector} from "react-redux";
import {CHANGE_LOCATIONS} from "../store";
import {useEffect, useState} from "react";
import {FOUR_SPORT_LIVE_URL} from "../constants";

interface IProps {
    Visible: boolean
    CloseModal: () => void
    Comp: number
}

interface IState {
    displayReducer: {
        SelectedLocations: string[]
    }
}

interface ITimeCodeLocationsResponse {
    locations: string[]
}

export default function LocationModal(props: IProps) {
    const [locations, setLocations] = useState<string[]>([])
    const [loading, setLoading] = useState<boolean>(false)
    const selectedLocations = useSelector((state: IState) => state.displayReducer.SelectedLocations);
    const dispatch = useDispatch()

    useEffect(()=> {
        setLoading(true)
        fetch(`${FOUR_SPORT_LIVE_URL}/caruz/getTimeCodeLocations/?comp=${props.Comp}`, {
            headers: {
                'Accept': 'application/json',
                'Authorization': 'Token ' + localStorage.getItem('caruzToken')
            },
        }).then(response => response.json()).then((response: ITimeCodeLocationsResponse) => {
            setLocations(response.locations)
            setLoading(false)
        })
    }, [props.Comp])

    return(

        <Modal
            visible={props.Visible}
            width="300px"
            footer={null}
            className="admin-user-details-modal"
            onCancel={props.CloseModal}
        >
            <Spin
                spinning={loading}
            >
                <ul style={{listStyle: 'none'}}>
                    {locations.map(location => {
                        return <li key={location}>
                            <Checkbox
                                checked={selectedLocations.includes(location)}
                                onChange={() => dispatch({
                                    type: CHANGE_LOCATIONS,
                                    payload: {
                                        location: location
                                    }
                                })}
                            />{' '}{location}
                        </li>
                    })}
                </ul>
            </Spin>
        </Modal>

    )
}